var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "justify-center-mobile",
      staticStyle: { display: "flex", "min-height": "100vh" }
    },
    [
      _c(
        "b-sidebar",
        {
          staticClass: "show-navbar-lg nav-mod-admin",
          attrs: { visible: "", "no-header": "", shadow: "" }
        },
        [
          _c(
            "nav",
            { staticClass: "mb-3" },
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "perfil" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("perfil")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myProfile")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "favoritos" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("favoritos")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("saveds")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "notificaciones" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("notificaciones")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myNotifications")))]
                  ),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "validaciones" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("validaciones")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("validations")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "reportes" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("reportes")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("reports")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("b-icon-three-dots-vertical", {
        directives: [
          {
            name: "b-toggle",
            rawName: "v-b-toggle.sidebar-admin",
            modifiers: { "sidebar-admin": true }
          }
        ],
        staticClass: "three-dots-admin show-navbar-mobile",
        attrs: { scale: "1.5" }
      }),
      _vm._v(" "),
      _c(
        "b-sidebar",
        {
          attrs: { id: "sidebar-admin", "no-header": "", shadow: "" },
          model: {
            value: _vm.showSideBarAdmin,
            callback: function($$v) {
              _vm.showSideBarAdmin = $$v
            },
            expression: "showSideBarAdmin"
          }
        },
        [
          _c(
            "nav",
            { staticClass: "mb-3" },
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "perfil" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("perfil")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myProfile")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "favoritos" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("favoritos")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("saveds")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticStyle: { "margin-right": "0px" },
                      attrs: { active: _vm.section === "notificaciones" },
                      on: {
                        click: function($event) {
                          return _vm.showSection("notificaciones")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("myNotifications")))]
                  ),
                  _vm._v(" "),
                  _vm.$store.getters["forum/forumUserIsAdminRole"]
                    ? _c(
                        "b-nav-item",
                        {
                          staticStyle: { "margin-right": "0px" },
                          attrs: { active: _vm.section === "validaciones" },
                          on: {
                            click: function($event) {
                              return _vm.showSection("validaciones")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("validations")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-button",
            {
              on: {
                click: function($event) {
                  _vm.showSideBarAdmin = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-column column-content" }, [
        _c("h1", { staticStyle: { "margin-bottom": "2%" } }, [
          _vm._v(_vm._s(_vm.sectionTitle))
        ]),
        _vm._v(" "),
        _vm.section === "perfil"
          ? _c(
              "div",
              [
                _vm._l(_vm.sectionInputs[_vm.section], function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _c("base-input", {
                        staticClass: "centerInput",
                        attrs: {
                          width50: "",
                          id: item.id,
                          tooltip: item.tooltip,
                          readonly: item.readonly,
                          label: item.label,
                          placeholder: item.placeholder,
                          type: item.type
                        },
                        on: {
                          keyup: function($event) {
                            _vm.showSaveBtn = true
                          }
                        },
                        model: {
                          value: item.value,
                          callback: function($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value"
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.showSaveBtn
                  ? _c(
                      "base-button",
                      {
                        staticClass: "btn-control",
                        on: { click: _vm.sendData }
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "notificaciones"
          ? _c(
              "div",
              [
                _vm._l(_vm.sectionInputs[_vm.section], function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      !item.customName
                        ? _c(
                            "b-form-checkbox",
                            {
                              attrs: { switch: "" },
                              on: {
                                change: function($event) {
                                  return _vm.notificationsSwitch(item.fn)
                                }
                              },
                              model: {
                                value: item.value,
                                callback: function($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "label-align",
                                domProps: { innerHTML: _vm._s(item.label) }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("receiveEmails") && item.value
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              placeholder: _vm.$t("panelEmailInterval"),
                              options: _vm.emailsDaysIntervalSource,
                              label: "name",
                              reduce: function(x) {
                                return x.days
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEmailInterval")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.emailsDaysInterval,
                              callback: function($$v) {
                                _vm.emailsDaysInterval = $$v
                              },
                              expression: "emailsDaysInterval"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("categories") &&
                      _vm.showCategoriesSelector
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              multiple: "",
                              placeholder: _vm.$t("panelEntryCategory"),
                              options: _vm.categoriesSource,
                              filtered: "",
                              searchable: "",
                              label: "name",
                              reduce: function(x) {
                                return x.id
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              },
                              search: _vm.getCategories
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEntryCategory")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.categories,
                              callback: function($$v) {
                                _vm.categories = $$v
                              },
                              expression: "categories"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.id.includes("tags") && _vm.showTagsSelector
                        ? _c("v-select", {
                            staticClass: "notificationsSelector",
                            attrs: {
                              multiple: "",
                              placeholder: _vm.$t("panelEntryTags"),
                              options: _vm.tagsSource,
                              filtered: "",
                              searchable: "",
                              label: "name",
                              reduce: function(x) {
                                return x.id
                              }
                            },
                            on: {
                              "option:selected": function($event) {
                                _vm.showSaveBtn = true
                              },
                              search: _vm.getTags
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("panelEntryTags")) +
                                          "\n          "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.tags,
                              callback: function($$v) {
                                _vm.tags = $$v
                              },
                              expression: "tags"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.showSaveBtn
                  ? _c(
                      "base-button",
                      {
                        staticClass: "btn-control",
                        on: { click: _vm.sendData }
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "favoritos"
          ? _c(
              "div",
              [
                _c(
                  "b-nav",
                  {
                    staticClass: "centerInput",
                    staticStyle: { "margin-bottom": "2%" }
                  },
                  [
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.favouritesSectionSelected === "entries"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showFavouritesSection("entries")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "black" }, [
                          _vm._v(_vm._s(_vm.$t("entries")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.favouritesSectionSelected === "messages"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showFavouritesSection("messages")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "black" }, [
                          _vm._v(_vm._s(_vm.$t("messages")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.favouritesSectionSelected === "entries"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.articleData &&
                        _vm.$store.state.forum.articleData.length > 0
                          ? _c("forum-article-block", {
                              attrs: { hideFooter: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noEntriesSaved
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("noEntriesSaved")))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.favouritesSectionSelected === "messages"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.messages
                          ? _c("forum-message-block", {
                              attrs: { hideOptions: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noMessagesSaved
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("noMessagesSaved")))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "validaciones"
          ? _c(
              "div",
              [
                _c(
                  "b-nav",
                  {
                    staticClass: "centerInput",
                    staticStyle: { "margin-bottom": "2%" }
                  },
                  [
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.validationsSectionSelected === "messages"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showValidationsSection("messages")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("messages")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-nav-item",
                      {
                        staticStyle: { "margin-right": "0px" },
                        attrs: {
                          active: _vm.validationsSectionSelected === "entries"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showValidationsSection("entries")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("entries")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.validationsSectionSelected === "messages"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.messages
                          ? _c("forum-message-block", {
                              attrs: {
                                hideOptions: "",
                                showValidateMessage: ""
                              },
                              on: {
                                updateValidatedMessages:
                                  _vm.loadValidationsMessages
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noMessagesPendingValidation
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("noMessagesPendingValidation"))
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.validationsSectionSelected === "entries"
                  ? _c(
                      "div",
                      [
                        _vm.$store.state.forum.articleData &&
                        _vm.$store.state.forum.articleData.length > 0
                          ? _c("forum-article-block", {
                              attrs: {
                                hideFooter: "",
                                disableClick: "",
                                showValidateEntry: ""
                              },
                              on: {
                                updateValidatedEntries:
                                  _vm.loadValidationsEntries
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.noEntriesPendingValidation
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("noEntriesPendingValidation"))
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.section === "reportes"
          ? _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _vm.$store.state.forum.messages
                      ? _c("forum-message-block", {
                          attrs: { hideOptions: "", showReportMessage: "" },
                          on: {
                            updateReportedMessages: _vm.loadReportedMessages
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.noMessagesReported
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("noMessagesReported")))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn-panel btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad40e27a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad40e27a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/ForumControlPanel.vue
// module id = 1735
// module chunks = 116